import React from 'react';

class Endseite extends React.Component {
  render() {
      return(
        <div>

          <div className="Inhalt noFlex">

            <h1>NOT A GAME </h1>
            <p> Du bist nun am Ende deiner Reise angekommen!
            Oder nicht? Wer weiß, ob dein Boot gesunken ist?
            Dein Schlepper hätte entdeckt werden können oder jemand aus deiner Gruppe krank
            werden.
            </p>
            <p>
            Und wenn du nun in deinem Zielland bist, wird dein Asylantrag angenommen werden?
            Wirst du die Sprache lernen und ein Teil der Gesellschaft werden können?
            Das kann dir niemand sagen, aber das ist ja auch nicht so schlimm...
            </p>
            <p>
            Denn für dich war das alles nur "ein Spiel".<b> Aber eine Flucht ist eben kein Spiel.</b>
            Die Entscheidungen, die für dich nur ein Klick auf einen Button waren, mussten
            andere Menschen wirklich treffen, ohne zu wissen, was die Folgen davon sind.
            Andere Menschen mussten ihre Heimat wirklich verlassen, wegen Krieg oder aus
            anderen Gründen. Was diese Leute durchgemacht haben, können wir uns gar nicht
            vorstellen, auch nicht durch eine Website.
            Und was jetzt kommt, ist sehr wichtig.
            <b> Wir wollen auf gar keinen Fall so tun, als wüssten wir, wie Geflüchtete sich
            fühlen und was sie erleben.</b>
            Aber wir möchten ein Bewusstsein dafür schaffen, vor welchen Hürden und Problemen
            Leute stehen, die ihre Heimat verlassen müssen, weil es dort nicht mehr lebenswert
            ist.
            </p>
          </div>
          
          <div className="Background">
            <div className="Gradient"></div>
            <div className="Image"></div>
          </div>
      </div>
      )
    }
}

export default Endseite;
